import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '@spartacus/core';
import { UserCurrentAdapter } from './user-current.adapter';

@Injectable()
export class UserCurrentConnector {
  constructor(protected adapter: UserCurrentAdapter) {}

  get(userId: string): Observable<User> {
    return this.adapter.load(userId);
  }
}
